import { DSButton } from "components/UI/atoms";
import "./index.scss";

export const BrandAlertSuccessFeedback = ({ name, handleClose }) => {
  return (
    <div
      className="brand-alert-success-feedback"
      data-testid="brand-alert-success-feedback"
    >
      <p>We'll email you when {name || ""} gift cards become available.</p>
      <DSButton
        variant="secondary"
        customClassName="alert-close-modal"
        onClick={handleClose}
      >
        Keep Shopping
      </DSButton>
    </div>
  );
};
